<template>
  <el-row :gutter="20" class="sec_box d2-mt-10" v-loading="loading">
    <template v-if="ListData.length != 0" v-loading='loadsing'>
      <el-button class="d2-fr" type="primary" icon="el-icon-circle-check" size="small" @click="allRead">一键已读</el-button>
      <el-col :span="24" v-for="(item, index) in ListData" :key="index" class="list_item_box" :title="item.Title">
        <i class="el-icon-document" color='#5cb6ff' style="font-size:30px;color:#5cb6ff"></i>
        <a class="list_item_info" v-if="item.Link && item.Link.indexOf('webView')!=-1" :href="webView(item.Link)">
          <p class="list_item_title">{{ item.Category || "-" }}</p>
          <div class="list_item_content">{{ innerText(item.Content) }}</div>
          <span class="list_item_time">{{ item.CreateTime || "-" }}</span>
        </a>
        <div v-else class="list_item_info" @click="listDetialHandle(index,item)">
          <p class="list_item_title">{{ item.Category || "-" }}</p>
          <div class="list_item_content">{{ innerText(item.Content) }}</div>
          <span class="list_item_time">{{ item.CreateTime || "-" }}</span>
        </div>
        <div class="align-center">
          <template v-if="!item.isRead && item.isRead!=false"></template>
          <template v-else>
            <div :class="['list_item_circle', item.isRead ? '' : 'active']"></div>
          </template>
        </div>
      </el-col>
      <el-col :span="24" class="align-center mt-20">
        <span class="no_more">没有更多了~</span>
      </el-col>
    </template>
    <template v-else>
      <el-empty class="auto"></el-empty>
    </template>
    <!--  -->
    <el-dialog :title="messageDetial.Title" :visible.sync="dialogVisible" width="40%">
      <el-card :body-style="{ padding: '0px' }">
        <div slot="header" class="clearfix">
          <span>{{type}} </span>
          <time class="time" style="float: right; padding: 3px 0;font-size:12px;color:#E3A23E"><i
              class="el-icon-time"></i>
            发布时间：{{ messageDetial.CreateTime || "-" }}</time>
        </div>
        <div style="padding: 14px">
          <div v-html="webView(messageDetial.Content)"></div>
          <div class="card_question_bottom clearfix">
          </div>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
  import * as indexService from "@/api/sys/index";
  export default {
    name: "listMessage",
    data() {
      return {
        dialogVisible: false,
        loadsing: false,
        messageDetial: {},
        type: ''
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    created() {},
    mounted() {},
    methods: {
      listDetialHandle(index, item) {
        console.log(index, item)
        if (item.isRead == false) {
          let parma = {
            dataId: item.ID
          }
          indexService.UpMsgIsRead(parma).then((data) => {
            this.GetMsgData(index, item)
          }).catch((e) => {
            this.$message.error(e.message);
          });
        } else {
          this.GetMsgData(index, item)
        }
      },
      GetMsgData(index, item) {
        let query = {
          dataId: item.ID,
          detailed: false,
          fiter: "",
          shortTitle: ""
        }
        indexService.GetMsgData(query).then((data) => {
          this.dialogVisible = true;
          this.messageDetial = data.data.mainData
          this.type = item.Category
          this.ListData[index].isRead = true
        }).catch((e) => {
          this.$message.error(e.message);
          this.dialogVisible = false;
        });
      },
      innerText(value) {
        var oDiv = document.createElement("div");
        oDiv.innerHTML = value;
        var text = oDiv.innerText;
        try {
          document.removeChild(oDiv);
        } catch (e) {

        }
        text = text.replace(/\s+/g, "");
        return text;
      },
      webView(value) {
        if (value && value.indexOf('webView') !== -1) {
          value = value.replace("webView", "#/webView")
        }
        return value
      },
      allRead() {
        this.$confirm('是否要将您的消息一键标为已读?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loadsing = true;
          indexService.SetAllRead().then(() => {
            this.$message.success("操作成功！");
            this.loadsing = false;
            this.$emit('message')
          }).catch((e) => {
            this.$message.error(e.message);
            this.loadsing = false;
          });
        }).catch(() => {

        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";

  /deep/ .el-dialog__body {
    padding: 5px 20px;
  }
</style>